
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/feriehus-hytteutleie",
      function () {
        return require("private-next-pages/feriehus-hytteutleie.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/feriehus-hytteutleie"])
      });
    }
  